import { connect } from 'react-redux';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Column, Row } from 'simple-flexbox';
import cx from 'classnames';
import { createStyles, useTheme, withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { ReactComponent as LogoutIcon } from 'assets/icons/logout.svg';
import { ReactComponent as HelpIcon } from 'assets/icons/help.svg';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import LogoComponent from './LogoComponent';
import { fetchUser } from '../../../reducers/user';
import useMediaQuery from '@material-ui/core/useMediaQuery';

 const withMediaQuery = (queries = []) => Component => props => {
  const mediaProps = {}
  queries.forEach(q => {
    mediaProps[q[0]] = useMediaQuery(q[1])
  })
  return <Component {...mediaProps} {...props} />
}

const styles = (theme) =>
  createStyles({
    root: {
      '& .MuiListItem-root': {
        borderLeft: '2px solid transparent',
        '&:hover':{
          backgroundColor: theme.palette.primary['200']
        }
      },
      '& .Mui-selected': {
        'color': theme.palette.text.primary,
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary['200'] ,
        '& .MuiListItemIcon-root': {
          color: theme.palette.primary.main,
          opacity: 1,
          "& svg path":{
            fill: theme.palette.primary.main
          },
        },
        '& .MuiListItemText-primary': {
          fontWeight: 700,
        }
      },
      '& .MuiListItemIcon-root': {
        minWidth: 36,
        opacity: 0.5,
        color: theme.palette.text.secondary,
        "& svg path":{
          fill: theme.palette.text.secondary
        },
      },
    },
    container: {
      backgroundColor: '#FFFFFF',
      width: 280,
      paddingTop: 32,
      height: '100%',
      overflow: 'auto',
    },
    containerMobile: {
      transition: 'left 0.5s, right 0.5s',
      position: 'absolute',
      width: 300,
      height: '100%',
      zIndex: 901,
      overflow: 'auto',
    },
    mainContainer: {
      height: '100%',
      minHeight: '100vh',
      border: 'solid',
      borderWidth: '0 1px 0 0',
      borderColor: '#e3ebf6',
    },
    mainContainerMobile: {
      position: 'absolute',
      top: 0,
      left: 0,
    },
    mainContainerExpanded: {
      width: '100%',
      minWidth: '100vh',
    },
    menuItemList: {
      marginTop: 36,
    },
    outsideLayer: {
      position: 'absolute',
      width: '100vw',
      minWidth: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,.50)',
      zIndex: 900,
    },
    hide: {
      left: -300,
    },
    show: {
      left: 0,
    },
    badge: {
      backgroundColor: theme.palette.secondary.main,
      color: 'white',
      padding: '1px 5px',
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
    },
    inboxChildrenMenu: {
      'paddingTop': 0,
      'paddingBottom': 10,
      '& .MuiListItem-button': {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 56,
      },
    },
  });

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchUser: (_) => dispatch(fetchUser),
  };
};
class SidebarComponent extends React.Component {
  constructor(props) {
    super(props);
    this.props.onFetchUser();
  }

  render() {
    const { classes, content, role, expanded, isMobile, toggleMenu } = this.props;

    return (
      <div className={classes.root}>
        <Row
          className={classes.mainContainer}
          breakpoints={{
            1024: cx(
              classes.mainContainerMobile,
              expanded && classes.mainContainerExpanded,
            ),
          }}
        >
          <Column
            className={classes.container}
            breakpoints={{
              1024: cx(
                classes.containerMobile,
                expanded ? classes.show : classes.hide,
              ),
            }}
          >
            <LogoComponent />
            <List>
              {content.map((content, index) => (
                <React.Fragment key={index}>
                  <ListItem
                    button
                    component={NavLink}
                    to={content.url}
                    exact={content.url === '/'}
                    activeClassName="Mui-selected"
                  >
                    <ListItemIcon>
                      {content.icon && React.createElement(content.icon)}
                    </ListItemIcon>
                    <ListItemText
                      primary={content.title}
                      secondary={content.subtitle}
                      secondaryTypographyProps={{
                        variant: 'caption'
                      }}
                    />
                    {content.renderSecondary &&
                      content.renderSecondary(classes)}
                  </ListItem>
                  {content.Children && (
                    <content.Children classes={classes} role={role} />
                  )}
                </React.Fragment>
              ))}
              <Divider />
              <ListItem button component="a" target="_blank" href="http://help.weadmit.io">
                <ListItemIcon>
                  <HelpIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Help"
                />
              </ListItem>
              <ListItem
                button
                component={NavLink}
                activeClassName="Mui-selected"
                to="/logout"
              >
                <ListItemIcon>
                  <LogoutIcon fontSize="small"  />
                </ListItemIcon>
                <ListItemText
                  primary="Logout"
                />
              </ListItem>
            </List>
          </Column>
          {isMobile && expanded && (
            <div className={classes.outsideLayer} onClick={toggleMenu} />
          )}
        </Row>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withStyles(styles)(
    withMediaQuery([
      [
        'isMobile',
        (theme) => theme.breakpoints.down('sm'),
        {
          defaultMatches: true,
        },
      ],
    ])(SidebarComponent),
  ),
);
